'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _company = require('../../redux/modules/company');






var _messageModal = require('../../redux/modules/messageModal');




var _components = require('../../components');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _HeaderPhones = require('../../components/Company/HeaderPhones/HeaderPhones');var _HeaderPhones2 = _interopRequireDefault(_HeaderPhones);
var _ConsultationForm = require('../../components/Company/ConsultationForm/ConsultationForm');var _ConsultationForm2 = _interopRequireDefault(_ConsultationForm);

var _RealtorsAssociationContainer = require('./RealtorsAssociationContainer.scss');var styles = _interopRequireWildcard(_RealtorsAssociationContainer);

var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);

var _constants = require('./constants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var











RealtorsAssociationContainer = function (_Component) {_inherits(RealtorsAssociationContainer, _Component);function RealtorsAssociationContainer() {var _temp, _this, _ret;_classCallCheck(this, RealtorsAssociationContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      captcha: null }, _this.









    fetchReCaptchaToken = function (token) {
      _this.setState({ captcha: token });
    }, _this.

    openSuccessMessage = function () {return _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', { className: 'successMessage' },
          _react2.default.createElement('span', null, _this.props.translate('companyPage', 'contactsForm', 'submitting_success'))),


        messageModalClassName: 'company-message-modal' });}, _this.


    formConsultationSubmitHandler = function (formValues) {var
      captcha = _this.state.captcha;

      _this.props.sendCompanyContactUsForm(Object.assign({},
      formValues, {
        captcha: captcha,
        receiver_name: _constants.REALTORS_ASSOCIATION_NAME_SHORT,
        to: _constants.REALTORS_ASSOCIATION_EMAIL }));

    }, _this.

    renderShareButton = function () {
      var sharingData = {
        sharingUrl: (0, _makeSharingUrl2.default)('/professionals/realtors_association', _this.props.locale),
        sharingTitle: _constants.REALTORS_ASSOCIATION_NAME[_this.props.locale] };


      return (
        _react2.default.createElement(_components.ShareButtonsRow, {
          isNative: _this.props.isNative,
          sharingData: sharingData,
          isMobile: _this.props.isMobile,
          locale: _this.props.locale,
          copyLinkTitle: '' + _this.props.translate('copyLink'),
          shareTitle: '' + _this.props.translate('companyPage', 'shareTitle'),
          className: 'realtorsAssociation',
          isHideShareTitle: true }));


    }, _this.

    renderDescription = function () {return (
        _react2.default.createElement('div', { className: styles.description },
          _react2.default.createElement('div', { className: styles.descriptionTitle }, _constants.REALTORS_ASSOCIATION_TITLE[_this.props.locale]),
          _react2.default.createElement('div', { className: styles.descriptionMain }, _constants.REALTORS_ASSOCIATION_DESCRIPTION_MAIN[_this.props.locale]),
          _react2.default.createElement('br', null),
          _react2.default.createElement('div', { className: styles.descriptionTitle }, _constants.REALTORS_ASSOCIATION_DESCRIPTION_TITLE[_this.props.locale]),
          _react2.default.createElement('div', { className: styles.listBlock },
            _constants.REALTORS_ASSOCIATION_DESCRIPTION_ADVANTAGES.map(function (item) {return (
                _react2.default.createElement('li', null,
                  _react2.default.createElement('span', { className: 'icon icon-check' }),
                  item[_this.props.locale]));}))));}, _this.






    renderConsultationForm = function (companyName, className, field_id) {return (
        _react2.default.createElement(_ConsultationForm2.default, {
          fetchReCaptchaToken: _this.fetchReCaptchaToken,
          locale: _this.props.locale,
          field_id: field_id,
          companyName: companyName,
          className: className,
          translate: _this.props.translate,
          onSubmit: _this.formConsultationSubmitHandler,
          isRtl: _this.props.isRtl,
          formSubmitting: _this.props.formSubmitting,
          formSubmitted: _this.props.formSubmitted,
          formConsultationError: _this.props.formError }));}, _this.



    renderDesktopContent = function () {return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.topWrap, styles.realtorsAssociationWrap) },
          _react2.default.createElement('span', { className: styles.bgCover }),
          _react2.default.createElement('div', { className: styles.container },
            _react2.default.createElement('div', { className: styles.content },
              _react2.default.createElement('div', { className: styles.logo },
                _react2.default.createElement('img', { src: _constants.REALTORS_ASSOCIATION_LOGO, alt: 'REALTORS_ASSOCIATION_LOGO' })),

              _react2.default.createElement('div', null,
                _react2.default.createElement('h1', { className: styles.title }, _constants.REALTORS_ASSOCIATION_NAME[_this.props.locale]),
                _react2.default.createElement(_HeaderPhones2.default, {
                  translate: _this.props.translate('companyPage'),
                  phoneNumber: _constants.REALTORS_ASSOCIATION_PHONE,
                  locale: _this.props.locale,
                  isMobile: _this.props.isMobile,
                  className: 'realtorsAssociationPhone' }),

                _react2.default.createElement('br', null),
                _this.renderConsultationForm(_constants.REALTORS_ASSOCIATION_NAME[_this.props.locale], 'realtorsAssociationHeaderTopForm', 'realtor_association_name_form'),

                _this.renderShareButton())))));}, _temp), _possibleConstructorReturn(_this, _ret);}RealtorsAssociationContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {if (!this.props.formSubmitted && nextProps.formSubmitted) {this.props.reset();this.openSuccessMessage();}};RealtorsAssociationContainer.prototype.






  render = function render() {
    return (
      _react2.default.createElement('div', null,
        this.renderDesktopContent(),
        this.renderDescription()));


  };return RealtorsAssociationContainer;}(_react.Component);


RealtorsAssociationContainer.propTypes = {
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  formSubmitted: _propTypes2.default.bool,
  formSubmitting: _propTypes2.default.bool,
  formError: _propTypes2.default.object,
  isModalShareOpen: _propTypes2.default.bool,
  location: _propTypes2.default.object,
  sendCompanyContactUsForm: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  reset: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    locale: state.lang.locale,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    isMobile: state.windowDimentions.isMobile,
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    formSubmitted: state.company.formSubmitted,
    formSubmitting: state.company.formSubmitting,
    formError: state.company.formError,
    isNative: state.native.isNative,
    isModalShareOpen: state.shareModal.isModalShareOpen };};


var mapDispatchToProps = {
  openCompanyContactModal: _company.openCompanyContactModal,
  closeCompanyContactModal: _company.closeCompanyContactModal,
  sendCompanyContactUsForm: _company.sendCompanyContactUsForm,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  reset: _company.reset };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RealtorsAssociationContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RealtorsAssociationContainer/RealtorsAssociationContainer.js
// module id = 2986
// module chunks = 0